export default class AtcButton extends HTMLElement {
  constructor() {
    super();
    this.submitForm = this.closest('form[action="/cart/add"]');
    this.errorMessage = this.submitForm.querySelector(".error-message");
  }

  connectedCallback() {
    this.submitForm.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();

    const id = this.submitForm.querySelector('input[name="id"]').value;
    const quantity = this.submitForm.querySelector(
      'input[name="quantity"]',
    ).value;
    const sellingPlan =
      this.submitForm.querySelector('input[name="selling_plan"]')?.value ||
      null;

    let formData = {
      items: [
        {
          id: id,
          quantity: quantity,
          selling_plan: sellingPlan,
        },
      ],
      sections: "cart-drawer,custom-cart-count",
    };

    console.log(formData);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.status === 422) {
          this.errorMessage.classList.remove("hidden");
          this.errorMessage.textContent = data.message;
          setTimeout(() => {
            this.errorMessage.classList.add("hidden");
            this.errorMessage.textContent = "";
            window.location.reload();
          }, 3000);
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:rerender", {
            detail: data,
            bubbles: true,
          }),
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("atc-button", AtcButton);
